import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { CreativeAdSize, CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { CreativePerformanceV1Component } from '../creative-performace-v1/creative-performance-v1.component';

@Component({
	selector: 'app-creatives-r5',
	styleUrls: ['./creatives-r5.component.css'],
	templateUrl: './creatives-r5.component.html'
})
export class CreativesR5Component
	extends CreativePerformanceV1Component
	implements OnInit, AfterViewChecked, WidgetCore, OnDestroy
{
	public reloadSubscription;
	public displayStats: any;
	@Input() sectiontitle: string;
	@Input() creativestats: any;
	@Input() legend: any;
	@Input() colorsconfig: any;
	public visibleDisplayStats: any;
	public selectedLegend;
	public isR11: boolean = false;
	public isR5: boolean = false;
	public isR9: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
	}

	ngAfterViewChecked(): void {
		jQuery('.inline' + this.displayStats.length).css('width', 100 / this.displayStats.length + '%');
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}

	ngOnInit(): void {
		this.isR11 = this.analyticsDataModel.config.version === 'R11' ? true : false;
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		this.isR5 = this.analyticsDataModel.config.version.toLowerCase() === 'r5';
		this.displayStats = JSON.parse(decodeURI(this.creativestats));
		this.visibleDisplayStats = JSON.parse(decodeURI(this.creativestats));
		this.legend = JSON.parse(decodeURI(this.legend));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.processLegendData();
		this.requestData();
	}

	moveToSelectedCarousel(index: number): void {
		this.carousel.moveTo(index);
		this.selectedIndex = index;
		this.currentCreativeData = JSON.parse(JSON.stringify(this.sortedCreatives[this.selectedIndex]));
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);
		const keys = [];

		// tslint:disable-next-line: forin
		for (const key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			} else {
				this.currentCreativeData[key] = this.currentCreativeData[key].toLocaleString();
			}
			if (key.startsWith('avg')) {
				keys.push({
					name: `Avg. ${key.charAt(3).toUpperCase()}${key.substr(4, key.length)}`,
					value: this.currentCreativeData[key]
				});
			} else {
				keys.push({ name: key.replace(/([A-Z])/g, ' $1').trim(), value: this.currentCreativeData[key] });
			}
		}
		this.currentCreativeStats = keys;
	}

	processResponseData(responseData: any): void {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			this.selectedLegend = _.findWhere(this.legend, { selected: true });
			this.graphData = this.generateGraphDataBySelection(this.selectedLegend.value);
			this.generateColumGraphData(this.graphData);
			this.hasGraphData = true;
		} else {
			this.hasData = false;
		}
	}

	mapResponseDataToInterface(responseData: any): CreativePerformance[] {
		const creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: CreativePerformance = {} as CreativePerformance;
			let location = '';
			const siteLinksArr = [];
			const structuredSnippetExtnArr = [];
			const calloutsExtnArr = [];
			let locationObj = {};
			let siteLinks = [];
			let structuredSnippetExtn = [];
			let calloutsExtn = [];
			creativeObj.creativeName = response.creative_name
				? response.creative_name
				: response.name
				? response.name
				: response.ad_headline;
			creativeObj.versionId = UtilityService.isUndefinedOrNull(response.cup_version_id)
				? 0
				: parseFloat(response.cup_version_id);
			creativeObj.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			creativeObj.clickRate = UtilityService.isUndefinedOrNull(response.click_rate)
				? UtilityService.isUndefinedOrNull(response.clickthroughrate)
					? 0
					: parseFloat(response.clickthroughrate)
				: parseFloat(response.click_rate);

			creativeObj.youtubeviews = UtilityService.isUndefinedOrNull(response.youtubeviews)
				? UtilityService.isUndefinedOrNull(response['youtube_verified_imprs'])
					? 0
					: parseFloat(response['youtube_verified_imprs'])
				: parseFloat(response.youtubeviews);
			creativeObj.youtubeviewRate = UtilityService.isUndefinedOrNull(response.youtubeview_rate)
				? UtilityService.isUndefinedOrNull(response['youtube_verified_imprs_rate'])
					? 0
					: parseFloat(response['youtube_verified_imprs_rate'])
				: parseFloat(response.youtubeview_rate);

			creativeObj.adInteractions = UtilityService.isUndefinedOrNull(response.ad_interactions)
				? 0
				: parseFloat(response.ad_interactions);
			creativeObj.adInteractionRate = UtilityService.isUndefinedOrNull(response.interaction_rate)
				? 0
				: parseFloat(response.interaction_rate);
			creativeObj.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			creativeObj.isCtv =
				this.sectiontitle.indexOf('TV Everywhere Creatives') !== -1 ||
				this.sectiontitle.indexOf('Connected TV Creatives') !== -1 ||
				this.sectiontitle.indexOf('CTV/OTT Creatives') !== -1 ||
				this.analyticsDataModel.getCurrentPath() === PATHS.CTV;
			creativeObj.isDisplay =
				this.sectiontitle.indexOf('Display') !== -1 || this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY;
			creativeObj.isSocial =
				this.sectiontitle.indexOf('Social') !== -1 || this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
			creativeObj.isPreRoll =
				this.sectiontitle.indexOf('Video Creatives') !== -1 ||
				this.sectiontitle.indexOf('Pre Roll Creatives') !== -1 ||
				this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
			creativeObj.isRadio =
				this.sectiontitle.indexOf('Audio') !== -1 || this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
			creativeObj.callExtension = response && response.call_extn ? JSON.parse(response.call_extn)[0][1] : '';
			if (response.location_extn) {
				try {
					locationObj = JSON.parse(response.location_extn)[0];
				} catch (e) {
					locationObj = {};
				}
				const locationArr = [];
				for (const prop in locationObj) {
					if (parseInt(prop, 10) > 1 && parseInt(prop, 10) < 8) {
						locationArr.push(locationObj[prop]);
					}
				}
				location = locationArr.join(', ');
				creativeObj.location = location;
			}

			if (response.url) {
				try {
					creativeObj.url = JSON.parse(response.url)[0];
				} catch (e) {
					creativeObj.url = response.url;
				}
			}
			creativeObj.adHeadline = UtilityService.isUndefinedOrNull(response.ad_headline) ? '' : response.ad_headline;
			creativeObj.clickthroughrate = UtilityService.isUndefinedOrNull(response.clickthroughrate)
				? 0
				: parseFloat(response.clickthroughrate);
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.avgPosition = response.avg_position;
			creativeObj.absTopImpression = response.abs_top_impression_share;
			creativeObj.absoluteTopImpression = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpression = response.top_impression_share;
			creativeObj.description = UtilityService.isUndefinedOrNull(response.description) ? '' : response.description;
			const temCreativeDesc = creativeObj.description.split('|');
			if (temCreativeDesc.length > 1) {
				creativeObj.description = temCreativeDesc;
			}
			if (response.sitelink_extn) {
				try {
					siteLinks = JSON.parse(response.sitelink_extn);
				} catch (e) {
					siteLinks = [];
				}
				for (const item of siteLinks) {
					siteLinksArr.push({
						// tslint:disable-next-line: prefer-template
						description: (item['3'] || '') + ' ' + (item['4'] || ''),
						heading: item['1'],
						link: Array.isArray(item['5']) ? item['5'][0] : item['5']
					});
				}
			}
			if (response.structuredsnippet_extn) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] !== '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.callouts_extn) {
				calloutsExtn = JSON.parse(response.callouts_extn);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}

			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativeObj.percentRate25 =
				this.isR5 && response['25_percent_rate_with_start_count']
					? response['25_percent_rate_with_start_count']
					: response['25_percent_rate'];
			creativeObj.percentValue25 = response['25_percent_value'];
			creativeObj.percentRate50 =
				this.isR5 && response['50_percent_rate_with_start_count']
					? response['50_percent_rate_with_start_count']
					: response['50_percent_rate'];
			creativeObj.percentValue50 = response['50_percent_value'];
			creativeObj.percentRate75 =
				this.isR5 && response['75_percent_rate_with_start_count']
					? response['75_percent_rate_with_start_count']
					: response['75_percent_rate'];
			creativeObj.percentValue75 = response['75_percent_value'];
			creativeObj.percentRate100 =
				this.isR5 && response['100_percent_rate_with_start_count']
					? response['100_percent_rate_with_start_count']
					: response['100_percent_rate'];
			creativeObj.percentValue100 = response['100_percent_value'];

			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			creativeObj.startCount = response.start_count ? response.start_count : null;
			creativeObj.siteLinks = siteLinksArr;
			creativeObj.isVideoCreative =
				(!UtilityService.isUndefinedOrNull(response.video_url) ||
					!UtilityService.isUndefinedOrNull(response.media_files) ||
					creativeObj.isPreRoll) &&
				!creativeObj.isSocial;
			creativeObj.isAudioCreative = !UtilityService.isUndefinedOrNull(response.audio_url);
			if(creativeObj.isSocial) {
				creativeObj.creativeThumbnail = response.creative_thumbnail_image && response.creative_thumbnail_image !== "" ? decodeURIComponent(response.creative_thumbnail_image.slice(response.creative_thumbnail_image.includes('http') ? response.creative_thumbnail_image.lastIndexOf('http') : 0)) : null;
				UtilityService.checkImageURLExpired(creativeObj.creativeThumbnail)
				.then((exists) => {
					if (!exists) {
					creativeObj.creativeThumbnail = null;
					}
				});
			} else {
			creativeObj.creativeThumbnail = UtilityService.isUndefinedOrNull(response.creative_thumbnail_image)
				? this.placeholderimage
				: UtilityService.checkEncodeURI(response.creative_thumbnail_image)
				? response.creative_thumbnail_image
				: encodeURI(response.creative_thumbnail_image);
			}
			creativeObj.hasSnapshotImage = !UtilityService.isUndefinedOrNull(response.snapshot_path);
			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			creativeObj.isIframeExpired = response.is_iframe_expired === 0 ? false : true;
			creativeObj.snapshotImage = response.snapshot_path;
			creativeObj.isNonManagedVideo = response.fetch_direct_video == "1" ? true : false;
			if (creativeObj.isVideoCreative) {
				creativeObj.creativeThumbnail = !creativeObj.isSocial ? response.thumbnail ? response.thumbnail : response.creative_thumbnail_image : null;
				creativeObj.creativeVideo = !UtilityService.isUndefinedOrNull(response.video_url)
					? response.video_url
					: response.media_files;
			}
			if (creativeObj.isAudioCreative) {
				creativeObj.audioURL = response.audio_url ? response.audio_url : null;
			}
			if (this.isR5) {
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response['100_percent_rate_with_start_count'])
					? UtilityService.isUndefinedOrNull(response['100_percent_rate_with_start_count'])
						? UtilityService.isUndefinedOrNull(response.completion_rate)
							? UtilityService.isUndefinedOrNull(response['100_percent_rate'])
								? 0
								: parseFloat(response['100_percent_rate']).toFixed(2)
							: parseFloat(response.completion_rate).toFixed(2)
						: parseFloat(response['100_percent_rate_with_start_count']).toFixed(2)
					: parseFloat(response['100_percent_rate_with_start_count']).toFixed(2);
			} else {
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
					? UtilityService.isUndefinedOrNull(response['100_percent_rate'])
						? 0
						: parseFloat(response['100_percent_rate']).toFixed(2)
					: parseFloat(response.completion_rate).toFixed(2);
			}
			creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
				? UtilityService.isUndefinedOrNull(response['100_percent_value'])
					? 0
					: parseInt(response['100_percent_value'], 10)
				: parseInt(response.completion_value, 10);
			if (response.creatives_by_ads) {
				creativeObj.adSizes = !creativeObj.isVideoCreative
					? this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : [])
					: ({} as { string: CreativeAdSize });
				creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			}
			if (response.creatives_by_date) {
				creativeObj.creativeStats = this.mapResponseToCreativeStats(response.creatives_by_date);
			}
			creativeObj.graphData = this.generateGraphDataByCreative(creativeObj.creativeStats);
			if (creativeObj.isSocial) {
				creativeObj.creativeThumbnail = creativeObj.creativeThumbnail ? creativeObj.creativeThumbnail : creativeObj.hasSnapshotImage ? creativeObj.snapshotImage : null;
				if (creativeObj.percentRate25 > 0) {
					creativeObj.isVideoCreative = false;
					if (this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL) {
						creativeObj.showStats = true;
					}
				} else {
					creativeObj.isVideoCreative = false;
					creativeObj.showStats = false;
				}
			}
			creativeObj.engagementDetails = this.mapEngagementDetails(response);
			creativeObj.engagements = response.engagements ? response.engagements : null;
			creativePerformances.push(creativeObj);
		}
		return creativePerformances;
	}

	getCreativeSize(thumbnail) {
		if (
			thumbnail?.includes('728x90') ||
			thumbnail?.includes('468x60') ||
			thumbnail?.includes('320x50') ||
			thumbnail?.includes('300x50')
		) {
			return '100% 30%';
		} else if (thumbnail?.includes('300x600')) {
			return '75% 100%';
		} else if (thumbnail?.includes('160x600')) {
			return '40% 100%';
		} else {
			return '100% 100%';
		}
	}

	mapEngagementDetails(response: any): any[] {
		const engagementDetails = [];
		const namesOfEngagements = ['likes', 'comments', 'shares', 'saves', 'reactions'];
		namesOfEngagements.forEach((detail: string) => {
			if (response[detail]) {
				engagementDetails.push({
					engagementName: detail,
					engagementValue: response[detail]
				});
			}
		});
		return engagementDetails;
	}

	generateColumGraphData(graphData: any): void {
		const categories = [];
		for (const category of graphData.categories) {
			if (moment(category, 'MM-DD-YYYY').weekday() === 1) {
				categories.push(-1);
				categories.push({
					date: category,
					value: 'M'
				});
			} else {
				categories.push({
					date: category,
					value: ''
				});
			}
		}
		for (const series of graphData.series) {
			const data = [];
			if (series) {
				for (const category of graphData.categories) {
					if (moment(category, 'MM-DD-YYYY').weekday() === 1) {
						data.push(0);
						data.push(graphData.series.data[category]);
					} else {
						data.push(graphData.series.data[category]);
					}
				}
			}
		}
		this.generatePlotLines(categories);
		this.graphData.categories = this.generatePlotLines(categories).categories;
		this.graphData.plotLines = this.generatePlotLines(categories).plotLines;
		this.graphData.plotOptions = {
			column: {
				stacking: 'normal'
			},
			series: {
				borderWidth: 0,
				pointWidth: 5
			}
		};
	}

	isTypeString(description: any): boolean {
		return typeof description === 'string';
	}

	generatePlotLines(categories: any): any {
		const plotLines = [];
		const lineObj = {
			color: '#e7e7e7',
			dashStyle: 'ShortDash',
			label: {
				enabled: false
			},
			value: 0,
			width: 1
		};
		// tslint:disable-next-line: no-parameter-reassignment
		categories = categories.map((val, index) => {
			if (val === -1) {
				lineObj.value = index;
				plotLines.push(JSON.parse(JSON.stringify(lineObj)));
				return '';
			} else {
				return val;
			}
		});
		return { categories, plotLines };
	}

	processSelectedLegendItem(legendItem: any): void {
		this.selectedLegend = legendItem;
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}

		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		selectedLegend.selected = true;
		this.processResponseData(this.responseData);
	}

	protected generateGraphDataBySelection(selectionItem: any): any {
		const sortedCreatives = this.sortCreativesBySelection(selectionItem);
		const series = [];
		let length = sortedCreatives.length;
		for (let i = 0; i < sortedCreatives.length; i++) {
			const seriesObj: any = {};
			seriesObj['name'] = sortedCreatives[i].creativeName;
			seriesObj['data'] = sortedCreatives[i].graphData[selectionItem];
			seriesObj['color'] = this.getColorFromColorConfig(i, 1);
			series.push(seriesObj);
			length--;
		}
		const categories = sortedCreatives.length > 0 ? sortedCreatives[0].graphData.dates : [];

		const graphData = { series, categories };
		this.sortedCreatives = _.compact(sortedCreatives);
		this.currentCreativeData = JSON.parse(JSON.stringify(this.sortedCreatives[this.selectedIndex]));
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);

		const keys = [];
		// tslint:disable-next-line: forin
		for (const key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			} else {
				this.currentCreativeData[key] = this.currentCreativeData[key]
					? this.currentCreativeData[key].toLocaleString()
					: this.currentCreativeData[key];
			}
			if (key.startsWith('avg')) {
				keys.push({
					name: `Avg. '${key.charAt(3).toUpperCase()}${key.substr(4, key.length)}`,
					value: this.currentCreativeData[key]
				});
			} else {
				keys.push({ name: key.replace(/([A-Z])/g, ' $1').trim(), value: this.currentCreativeData[key] });
			}
		}

		this.currentCreativeStats = keys;
		return graphData;
	}
}
